import { Listbox, Transition } from '@headlessui/react';
import { FC, Fragment } from 'react';
import { twMerge } from 'tailwind-merge';
import { SelectItem } from './SelectItem';
import { SelectOption } from './types';

type SelectOptionsListProps = {
  open: boolean;
  items: SelectOption[];
  classNames?: {
    wrapper?: string;
  };
};

export const SelectOptionsList: FC<SelectOptionsListProps> = ({ open, items, classNames }) => {
  return (
    <Transition
      show={open}
      as={Fragment}
      enter='transition ease-in duration-100'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='transition ease-in duration-150'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'
    >
      <Listbox.Options
        static
        className={twMerge(
          'absolute z-50 mt-2 w-full bg-white-100 shadow-lg max-h-60 rounded-lg py-1 px-1.5',
          'border border-secondary-border overflow-y-auto focus:outline-none',
          classNames?.wrapper
        )}
      >
        {items.map((item) => (
          <SelectItem key={item.id} item={item} />
        ))}
      </Listbox.Options>
    </Transition>
  );
};
